import { useMemo } from 'react';
import { buildFilter } from '@platform/core/lib/filterDsl';
import { conditionsToDsl } from './advancedFilter';
import { quickFieldsDsl } from './quickFieldFilters';
import { useAdvancedFilter } from './useAdvancedFilter';
import { useQuickFields } from './useQuickFields';

/** Фільтр-DSL розширених фільтрів типу запису: швидкі поля й повні рядки умов (undefined — фільтрів немає); для запиту списку й експорту. */
export function useAdvancedDsl(ws: string, rt: string): string | undefined {
  const [conditions] = useAdvancedFilter(ws, rt);
  const [quick] = useQuickFields(ws, rt);
  return useMemo(() => buildFilter([quickFieldsDsl(quick), conditionsToDsl(conditions)]) || undefined, [quick, conditions]);
}
